import { useDispatch, useSelector } from "react-redux";
import React, { useEffect } from "react";
import { ComponentError, ComponentNoData } from "../../../../components/ComponentLoader";
import PredictionCard from "./PredictionCard";
import ViewAllTitle from "components/ViewAllTitle";
import PredictionLoader from "./PredictionLoader";
import { loadPrediction } from "redux/slices/dynamicMultipleElementsSlice";

const Prediction = ({ section, mobile = true }) => {
  const { [section.value]: predictionCampaign } =
    useSelector((state) => state.dynamicMultipleElements.prediction);

  return (
    <MemoizedBrandMonthContent predictionCampaign={predictionCampaign} section={section} mobile={mobile} />
  );
};

export default React.memo(Prediction);

const PredictionList = ({
  predictionCampaign: { loading, data, init = false, error } = {},
  section,
  mobile
}) => {

  const dispatch = useDispatch();

  useEffect(() => {
    if (!init && !error && !loading) {
      dispatch(loadPrediction(section.value));
    }
  }, [init, loading, error]);

  return (
    <div className="w-full app-top-mg grid">
      <div className="relative grid-area min-w-0">
        {loading && !init ?
          <PredictionLoader mobile={mobile} />
          : error?.length > 0 ?
            <ComponentError error={error} />
            : (init && !data?.categories?.length) ?
              <ComponentNoData msg="This campaign has expired." /> :
              <div className={`container flex flex-col space-y-4 w-full px-3`}>
                {data?.categories?.map((d, index) => <PredictionCard prediction={d} key={`prediction-${index}`} mobile={mobile} />)}
              </div>
        }
      </div>
    </div>
  );
};


const MemoizedBrandMonthContent = React.memo(PredictionList);




